export const BASE_URL = 'https://api.logos.bg/api';
export const MEDIA_URL = 'https://api.logos.bg';
export const RECAPTCHA_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

export const SIZE_HIDE_MENU = 1200;
